import { Box, Divider, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Fragment } from 'react'

import DialogLayout from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.component'
import { SIZES } from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import { dateSortValue } from '@hapana/shared/utils/date.util'

import NoteWithBadge from '../note-with-badge.component'
import { styles } from '../notes-properties.styles'
import { TABS_VALUES } from '../modal-alerts.constants'

const ModalShowAllNotes = ({ alerts, username }) => {
  // We won't have a filter for iteration 2
  // const [badgeFilter, setBadgeFilter] = useState()
  // const [filteredNotes, setFilteredNotes] = useState(alerts)
  const { t } = useTranslation(['checkIn'])
  const { popDialog } = useDialog()

  // const formMethods = useForm({
  //   defaultValues: {},
  //   mode: 'onChange',
  // })

  // const value = formMethods.watch(BADGE_SELECT_FIELD_NAME)

  // We won't have a filter for iteration 2
  // useEffect(() => {
  //   if (value === '' || value === undefined) {
  //     setFilteredNotes(alerts)
  //   } else if (value !== undefined) {
  //     setBadgeFilter(value)
  //     let filteredData = alerts.filter(item => item.badge.toLowerCase() === badgeFilter)
  //     setFilteredNotes(filteredData)
  //   }
  // }, [alerts, badgeFilter, value])
  // const popAndCleanDialog = () => {
  //   popDialog(null, { previousModalTitle: '' })
  // }
  const handleBackClick = () => {
    popDialog({ tabDefaultValue: TABS_VALUES[1] })
  }

  const orderedAlertsByDate = [...alerts].sort(
    (a, b) => dateSortValue(b.date) - dateSortValue(a.date)
  )

  return (
    <>
      {/* <FormProvider {...formMethods}>
        <form> */}
      <DialogLayout
        size={SIZES.SM}
        hasBackLabel
        onCustomBackClick={handleBackClick}
        customBackLabel={
          t('checkIn:alerts.notesAndPropertiesHeader', {
            username,
          }) +
          ' ' +
          t('checkIn:totalAlerts', { count: alerts.length })
        }
      >
        <Box sx={styles.showAllContainer}>
          <Box sx={styles.alertHeaderContainer}>
            <Typography typography="header3" color="gray.80" sx={styles.totalNotes}>
              {alerts.length} {t('checkIn:alerts.notesAndPropertiesAlerts.notes')}
            </Typography>
            {/* <Box sx={styles.filterContainer}>
              <Select
                name={BADGE_SELECT_FIELD_NAME}
                placeholder={BADGE_DEFAULT_VALUE}
                options={NOTES_BADGE_OPTION}
                variant={SELECT_VARIANTS.GHOST}
              />
            </Box> */}
          </Box>
        </Box>
        {orderedAlertsByDate.map((item, index) => (
          <Fragment key={item.id}>
            <Box sx={styles.showAllContainer}>
              <NoteWithBadge
                // edited={item.edited}
                // badgeEdited={item.badgeEdited}
                // badge={item.badge}
                date={item.date}
                description={item.text}
              />
            </Box>
            {index !== alerts.length - 1 && <Divider />}
          </Fragment>
        ))}
      </DialogLayout>
      {/* </form>
      </FormProvider> */}
    </>
  )
}
export default ModalShowAllNotes

ModalShowAllNotes.propTypes = {
  alerts: PropTypes.array,
  username: PropTypes.string,
}
